// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.gray[data-v-fb70f1b6] {\n\tcolor: gray;\n}\n.fields-title[data-v-fb70f1b6] {\n\tmargin: 10px 0 0 0;\n\tcolor: var(--main-gray-6);\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
